import { accordion } from './accordion';
import { alert } from './alert';
import { badge } from './badge';
import { breadcrumb } from './breadcrumb';
import { button } from './button';
import { card } from './card';
import { checkbox } from './checkbox';
import { checkmark } from './checkmark';
import { dialog } from './dialog';
import { drawer } from './drawer';
import { emptyState } from './emptyState';
import { field } from './field';
import { heading } from './heading';
import { input } from './input';
import { inputAddon } from './inputAddon';
import { link } from './link';
import { mark } from './mark';
import { menu } from './menu';
import { numberInput } from './numberInput';
import { popover } from './popover';
import { progress } from './progress';
import { radioGroup } from './radioGroup';
import { radiomark } from './radiomark';
import { result } from './result';
import { segmentGroup } from './segmentGroup';
import { select } from './select';
import { stat } from './stat';
import { steps } from './stepper';
import { table } from './table';
import { tabs } from './tabs';
import { tag } from './tag';
import { textarea } from './textarea';
import { toast } from './toast';
import { tooltip } from './tooltip';

export const recipes = {
  badge,
  button,
  checkmark,
  heading,
  input,
  inputAddon,
  link,
  mark,
  radiomark,
  textarea,
};

export const slotRecipes = {
  accordion,
  alert,
  breadcrumb,
  card,
  checkbox,
  dialog,
  drawer,
  emptyState,
  field,
  menu,
  numberInput,
  popover,
  progress,
  radioGroup,
  result,
  segmentGroup,
  select,
  stat,
  steps,
  table,
  tabs,
  tag,
  toast,
  tooltip,
};
